import React from "react";
import HighlightCompanyName from "./HighlightCompanyName";

const WhyJoinUs = ({ content }) => {
  return (
    <section className="why-join-us" id="why-join-us">
      <div className="careers-container">
        <div className="section-heading section-heading--split">
          <div>
            <span className="section-heading__eyebrow">{content.eyebrow}</span>

            <h2 className="section-heading__title">{content.title}</h2>
          </div>

          <p className="section-heading__description">
            <HighlightCompanyName text={content.description} />
          </p>
        </div>

        <div className="why-join-us__statement">
          <span className="why-join-us__quote-mark">“</span>

          <p>
            Great technology starts with great people, great ideas, and the
            freedom to turn those ideas into meaningful solutions.
          </p>

          <span className="why-join-us__line" />
        </div>
      </div>
    </section>
  );
};

export default WhyJoinUs;
